"use client";

import { useEffect, useState } from "react";
import { useIsMounted } from "@/lib/useIsMounted";

/** Reads prefers-reduced-motion only after mount so SSR and first client render match. */
export function useMountedReducedMotion() {
  const mounted = useIsMounted();
  const [reduced, setReduced] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const sync = () => setReduced(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  return mounted ? reduced : false;
}
